import React from 'react';
import { Button } from 'rmwc/Button';
import gtagEvent from '../../utilities/analytics/gtag-event';

import './landing-pages.css';
import '@material/button/dist/mdc.button.min.css';

const heroUri = 'https://firebasestorage.googleapis.com/v0/b/quiver-four.appspot.com/o/marketing%2F640%2FDSC03464.JPG?alt=media&token=2d175a1d-dc7d-4c95-9f3a-47783d60a655';

export default props => {
  return (
    <article id="how-to-take-a-class" className="static-landing-page" role="main">
      <section className="centered">
        <div className="row">
          <div className="hide-small">
            <img className="hero" src={heroUri} alt="Melissa teaching a class" />
          </div>
          <div className="flex">
            <h1 className="headline-text">Is calligraphy for you?</h1>
            <p className="primary-text">
              Don't waste your time. Follow the steps below to find out.
            </p>
            <p className="secondary-text">
              <strong>Ask us!</strong> <br /> Email Chris at{' '}
              <a href="mailto:chris@calligraphy.org?subject=Calligraphy.org Questions&body=Hey Chris,">
                chris@calligraphy.org
              </a>{' '}
              and he'll answer your hardest questions.
            </p>
            <a href="https://store.calligraphy.org/">
              <Button
                className="cta-button"
                raised
                onClick={() => gtagEvent('cta-click', { page: 'how-to-take-a-class', position: 'primary' })}
              >
                Get started today
              </Button>
            </a>
          </div>
        </div>
      </section>
    </article>
  );
};
